import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  CircularProgress,
  Container,
  Typography,
  Box,
  Card,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import AppButton from "../../components/AppButton";
import { forgot } from "../../service/authService";
import Color from "../../components/Color";
import { useSnackbar } from "../../App"; // Import useSnackbar hook

const Forgot = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar(); // Use the snackbar hook
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      showSnackbar("Please enter your email", "error");
      return;
    }

    setLoading(true);

    try {
      await forgot(email);
      showSnackbar("OTP sent to your email", "success");
      localStorage.setItem("email", email);
      navigate("/otp");
    } catch (error) {
      const message = error?.response?.data?.message || "Failed to send OTP";
      showSnackbar(message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          p: { xs: 3, sm: 4 },
          boxShadow: "0px 4px 20px 4px rgba(0, 0, 0, 0.1)",
          borderRadius: 3,
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant={isMobile ? "h6" : "h5"}
          fontWeight="bold"
          gutterBottom
          textAlign="center"
        >
          Forgot Password
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <Box>
            <Typography
              sx={{
                mb: 1,
                fontWeight: "bold",
                color: Color.label.main,
                fontSize: "13px",
              }}
            >
              Email*
            </Typography>
            <TextField
              fullWidth
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email address"
              required
              autoComplete="email"
              variant="outlined"
              InputLabelProps={{ shrink: false }}
              sx={{
                "& .MuiInputLabel-root": { display: "none" },
              }}
            />
          </Box>

          {/* Submit Button */}
          <AppButton
            fullWidth
            type="submit"
            color="primary"
            disabled={loading}
            sx={{ mt: 3 }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </AppButton>

          {/* Back to Login Button */}
          <Button
            fullWidth
            onClick={handleCancel}
            sx={{
              mt: 1,
              background: "none",
              color: Color.label.main,
              border: "1px solid",
              borderColor: Color.secondary.main,
            }}
          >
            Back to Login
          </Button>
        </Box>
      </Card>
    </Container>
  );
};

export default Forgot;
